<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>                 
        </div>
    </div>
    <div class="row container-table">
        <div class="col-12">
            <table class="table table-striped table-hover datatables" id="tableItensUnidades">
                <thead>
                        <tr>
                            <th class="col-options"></th>
                            <th class="col-codigo-integracao-erp text-center">Código ERP</th>
                            <th class="col-nome">Nome</th>
                        </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities">
                        <td class="col-options">
                            <a (click)="edit(entity)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            <a (click)="delete(entity)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                        </td>
                        <td class="col-codigo-integracao-erp text-center">{{entity.codigoIntegracaoErp}}</td>
                        <td class="col-nome">{{entity.nome}}</td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    </div>    
</div>